import React from 'react';


function CheckoutFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <div
      className="footer2" style={{
        backgroundColor: '#000',
        paddingTop: '20px',
      }}
    >
      <div className="container">
        <p
          className="text-center" style={{
            fontSize: '12px',
            color: '#fff',
          }}
        >
          Copyright © 1999-{currentYear} Naked Broadcasting Network
          Inc. All Rights Reserved.
          <a href="/terms_of_service" style={{ color: '#fff' }}>Terms of Use</a>
          <br />
          &quot;Naked News&quot; is a registered trademark of Egalaxy
          Multimedia Inc.
        </p>
      </div>
    </div>
  );
}

export default React.memo(CheckoutFooter);
